import { render, staticRenderFns } from "./AddDropRequest.vue?vue&type=template&id=6a6d8fe8&scoped=true&"
import script from "./AddDropRequest.vue?vue&type=script&lang=js&"
export * from "./AddDropRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d8fe8",
  null
  
)

export default component.exports